import './index.scss';

import React, { Component } from 'react';

import OffeBurnTheCrownModal from '../../components/offer-burn-crown-modal';
import OffersVoucherCode from '../../components/offer-voucher-code';
import Modal from '../modal';

class OffersModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalContentType: this.setModalContentType(),
      modalContentValue: props.modalContentValue,
      voucherContentValue: props.modalContentValue
    };
  }

  componentDidUpdate(prevProps) {
    const { modalContentValue } = this.props;
    if (
      modalContentValue &&
      modalContentValue !== prevProps.modalContentValue
    ) {
      this.setModalContentValue(modalContentValue);
    }
  }

  setModalContentValue = data => {
    this.setState({ modalContentValue: data });
  };

  setModalContentType = () => {
    const { modalContentValue } = this.props;

    if (!modalContentValue) return '';

    if (
      modalContentValue.crowns_to_burn &&
      modalContentValue.is_redemed === false
    ) {
      return '';
    }

    if (
      modalContentValue.coupon_code ||
      modalContentValue.title ||
      (modalContentValue.is_product && modalContentValue.crowns_to_burn === 0)
    ) {
      return 'copyCode';
    }

    if (modalContentValue.offer_type === 'DISCOUNT') {
      return 'copyCode';
    }

    return '';
  };

  burnValueOnClick = () => {
    const { burnValueOnClick } = this.props;
    const { modalContentValue } = this.state;
    burnValueOnClick(modalContentValue);
    this.setState({ modalContentType: 'copyCode' });
  };

  renderContent = () => {
    const {
      modalContentType,
      modalContentValue,
      voucherContentValue
    } = this.state;
    const { burnValueOnClick } = this;
    const {
      closeOnClick,
      termsAndConditionClick,
      userAvailablePoints,
      couponCode,
      isVoucherCard,
      onClickButton,
      vouchersPageHandler,
      theme
    } = this.props;
    let dom;
    switch (modalContentType) {
      case 'copyCode':
        dom = (
          <OffersVoucherCode
            termsAndConditionClick={termsAndConditionClick}
            data={voucherContentValue}
            couponCode={couponCode}
            isVoucherCard={isVoucherCard}
            onClickButton={onClickButton}
            vouchersPageHandler={vouchersPageHandler}
            closeOnClick={closeOnClick}
            theme={theme}
          />
        );
        break;
      // case 'burnCrown':
      default:
        dom = (
          <OffeBurnTheCrownModal
            termsAndConditionClick={termsAndConditionClick}
            data={voucherContentValue}
            closeOnClick={closeOnClick}
            burnOnClick={burnValueOnClick}
            userAvailablePoints={userAvailablePoints}
            theme={theme}
          />
        );
        break;
      // default:
      //   dom = <p>No content available</p>;
    }
    return dom;
  };

  onCloseModal = () => {
    const { onCloseModal } = this.props;
    onCloseModal();
  };

  render() {
    const { renderContent, onCloseModal } = this;
    const { modalContentType } = this.state;
    const isMobileFullLayout = !modalContentType;

    const { theme } = this.props;
    const { innerWidth } = window;
    const contentCustomClass = !modalContentType ? 'offers-modal__no-bg' : '';
    return (
      <Modal
        onCloseHandler={onCloseModal}
        hideClose={innerWidth < 768 ? modalContentType !== 'copyCode' : false}
        isMobileFullLayout={isMobileFullLayout}
        contentCustomClass={contentCustomClass}
      >
        {renderContent()}
      </Modal>
    );
  }
}

export default OffersModalContent;
